import { css } from "@emotion/react"
import { colorsCP, fontsCP } from "../../Tokens"

export const iqText = css`
headings(viewport = '') {
  &--{viewport}heading-one, &--{viewport}heading-two, &--{viewport}heading-three, &--{viewport}heading-four, &--{viewport}heading-five, &--{viewport}heading-six {
    font-family: ${fontsCP['font-secondary']['font-family']};
    font-weight: 700;
  }

  &--{viewport}heading-one {
    font-size: 32px;
    line-height: 1.4;
  }

  &--{viewport}heading-two {
    font-size: 28px;
    line-height: 1.4;
  }

  &--{viewport}heading-three {
    font-size: 24px;
    line-height: 1.4;
  }

  &--{viewport}heading-four {
    font-size: 20px;
    line-height: 1.4;
  }

  &--{viewport}heading-five {
    font-size: 20px;
    line-height: 1.4;
  }

  &--{viewport}heading-six {
    font-size: 16px;
    line-height: 1.4;
  }
}
bodyText(viewport = '')
  color: ${colorsCP['neutral-70']};

  &--{vieport}body-extralarge, &--{vieport}body-large, &--{vieport}body-medium, &--{vieport}body-small, &--{vieport}body-micro {
    font-family: ${fontsCP['font-primary']['font-family']};
    font-weight: 400;
  }

  &--{viewport}body-extralarge {
    font-size: 20px;
    line-height: 1.4;
  }

  &--{viewport}body-large {
    font-size: 18px;
    line-height: 1.4;
  }

  &--{viewport}body-medium {
    font-size: 16px;
    line-height: 1.4;
  }

  &--{viewport}body-small {
    font-size: 14px;
    line-height: 1.4;
  }

  &--{viewport}body-micro {
    font-size: 12px;
    line-height: 1.4;
  }

numbers(viewport = '')
  &--{viewport}number-large, &--{viewport}number-medium, &--{viewport}number-small, &--{viewport}number-micro {
    font-family: ${fontsCP['font-secondary']['font-family']};
    font-weight: 400;
  }

  &--{viewport}number-large {
    font-size: 24px;
    line-height: 1.4;
  }

  &--{viewport}number-medium {
    font-size: 16px;
    line-height: 1.4;
  }

  &--{viewport}number-small {
    font-size: 14px;
    line-height: 1.4;
  }

  &--{viewport}number-micro {
    font-size: 12px;
    line-height: 1.4;
  }

.iq-text {
  font-family: ${fontsCP['font-primary']['font-family']};

  &--weight-300,
  &[weight="300"] {
    font-weight: 300;
  }

  &--weight-400,
  &[weight="400"]  {
    font-weight: 400;
  }

  &--weight-500,
  &[weight="500"]  {
    font-weight: 500;
  }

  &--weight-600,
  &[weight="600"]  {
    font-weight: 600;
  }

  &--weight-700,
  &[weight="700"]  {
    font-weight: 700;
  }

  &[class*="heading"] {
    font-family: ${fontsCP['font-secondary']['font-family']};

    &[class*="four"] {
      font-size: 20px;
    }
  }

  &--body-extralarge {
    font-size: 20px;
    line-height: 1.4;
  }

  headings()
  bodyText()
  numbers()

  +aboveSmall()
    headings("desk-")
    bodyText("desk-")
    numbers("desk-")
}
`
